import React from 'react'
import { Button } from '@material-ui/core'
import { AddCircleOutline, RemoveCircleOutline } from "@material-ui/icons";

export default class ManageRowSettings extends React.Component {
    render() {
        return (
            <Button
                onClick={async () => {
                    this.props.callback();
                }}
                style={{ width: 'fit-content', height: 'fit-content' }}
                variant={this.props.add ? 'contained' : 'text'}
                color={this.props.add ? 'primary' : 'secondary'}>
                {this.props.add && <AddCircleOutline style={{ color: '#fff' }} />}
                {!this.props.add && <RemoveCircleOutline />}
            </Button>
        )
    }
}